import React, {Component} from "react";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {RETAIL, SUPER_ADMIN, USER, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import {createLoanOrder} from "../../../actions/loan/loanOrderActions";
import {Alert, Button, Card, CardBody, CardTitle, Col, Form, Input, Row} from "reactstrap";
import {I18n} from "../../../I18n/components/loan";
import swal from "sweetalert";
import {fetchStores} from "../../../actions/storesActions";
import {fetchLoanBanks} from "../../../actions/loan/loanBankActions";
import {Link} from "react-router-dom";
import {fetchMaxNumberOfLoanPayments} from "../../../actions/loan/loanRetailerPropertyAction";
import {isLoansPermission} from "../../../helpers/companyService";

class LoanOrderCreation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            order: {
                phoneNumber: '',
                price: '',
                numberOfPayments: '',
                product: '',
                numberOfProducts: ''
            },
            isSaveDisable: false,
            expanded: false,
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        this.setState({expanded: urlParams.get('expanded') === "true"});

        const {authority, company, currentUser, lang} = this.props;

        (async () => {

            if (!isLoansPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            const storesPromise = await this.props.fetchStores({companyId: currentUser.companyId});
            const stores = storesPromise.data;

            if (!this.isRetail() || !this.isUser() || stores.length !== 1) {
                swal(I18n[lang].invalidUserError, "", "error")
                    .then(() => this.props.changeLocation(`/dashboard/loan/orders?expanded=${this.state.expanded}`));
                return;
            }

            await this.props.fetchMaxNumberOfPayments({
                //TODO implement logic with bank selection
                integration: 'MONOBANK',
                retailerId: currentUser.companyId,
                pointId: stores[0].id
            });
            await this.props.fetchBanks({size: 4});
        })();
    }

    isRetail = () => {
        const {authority, company} = this.props;
        return authority !== SUPER_ADMIN && company.types.includes(RETAIL);
    }

    isUser = () => {
        const {authority} = this.props;
        return authority === USER;
    }

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.value;
        this.setState(state => ({
            order: Object.keys(state.order).reduce((res, key) => {
                if (key === name) {
                    res[key] = value;
                } else {
                    res[key] = state.order[key];
                }
                return res
            }, {})
        }));
    };

    createOrderDto = () => {
        const {stores, currentUser} = this.props;
        const {order} = this.state;
        return {
            retailerId: currentUser.companyId,
            pointId: stores[0].id,
            userId: currentUser.userId,
            clientPhone: order.phoneNumber,
            parts: order.numberOfPayments,
            product: {
                name: order.product,
                sum: order.price,
                count: order.numberOfProducts
            }
        };
    }

    handleSubmit = async (event) => {
        const {lang} = this.props;
        const {expanded} = this.state;
        if (event) {
            event.preventDefault();
        }
        await this.setState({isSaveDisable: true});
        await this.props.createLoanOrder(this.createOrderDto(), lang)
            .then(response => {
                if (response) {
                    this.props.changeLocation(`/dashboard/loan/orders?expanded=${expanded}`);
                }
            }).catch(error => {
                let message = error && error.message ? error.message : JSON.stringify(error);
                swal(I18n[lang].error, message, "error");
            });
        await this.setState({isSaveDisable: false});
    };

    getNumberOfPaymentsOptions = () => {
        const {maxNumberOfPayments} = this.props;
        const values = Array.from({length: maxNumberOfPayments}, (_, index) => index + 1);
        let options = values.map((number) => (
            <option key={number} value={number}>
                {number}
            </option>
        ));
        options.unshift(<option/>);
        return options;
    }

    renderOrderForm = () => {
        const {lang, maxNumberOfPayments} = this.props;
        const {order} = this.state;
        return (
            <div className="loan-order-info mt-4">
                <div>
                    <div>{I18n[lang].phoneNumber + ": "}</div>
                    <Input
                        type="tel"
                        minLength="13"
                        placeholder="+380990000000"
                        name="phoneNumber"
                        id="phoneNumber"
                        required
                        value={order.phoneNumber}
                        onChange={this.onInputChange}
                    />
                </div>
                <div>
                    <div>{I18n[lang].price + ": "}</div>
                    <Input
                        type="number"
                        name="price"
                        id="price"
                        required
                        value={order.price}
                        onChange={this.onInputChange}
                    />
                </div>
                <div>
                    <div>{I18n[lang].numberOfPayments + ": "}</div>
                    <Input
                        type={maxNumberOfPayments ? "select" : "number"}
                        name="numberOfPayments"
                        id="numberOfPayments"
                        min="1"
                        required
                        value={order.numberOfPayments}
                        onChange={this.onInputChange}
                    >
                        {maxNumberOfPayments ? this.getNumberOfPaymentsOptions() : null}
                    </Input>
                </div>
                <div>
                    <div>{I18n[lang].product + ": "}</div>
                    <Input
                        type="text"
                        name="product"
                        id="product"
                        required
                        value={order.product}
                        onChange={this.onInputChange}
                    />
                </div>
                <div>
                    <div>{I18n[lang].numberOfProducts + ": "}</div>
                    <Input
                        type="number"
                        min="1"
                        name="numberOfProducts"
                        id="numberOfProducts"
                        required
                        value={order.numberOfProducts}
                        onChange={this.onInputChange}
                    />
                </div>
            </div>
        );
    }

    renderBankList = () => {
        const {loanBanks, lang} = this.props;
        return (
            <div>
                <h4 className='text-center mt-4'>{I18n[lang].creditors}</h4>
                <div className="loan-bank-list">
                    {loanBanks.map(bank =>
                        <img
                            src={bank.iconUrl}
                            alt="bank icon"
                        />
                    )}
                </div>
            </div>
        )
    }

    render() {
        const {lang} = this.props;
        const {isSaveDisable, expanded} = this.state;

        return (<div className={expanded ? "expanded" : null}>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card className={expanded ? "expanded" : null}>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-credit-card mr-2"/>
                            {I18n[lang].loanOrderCreation}
                        </div>
                    </CardTitle>

                    <CardBody>
                        {!expanded ? null :
                            <Link to={`/dashboard/loan/orders?expanded=${expanded}`}>
                                <Button
                                    color="secondary"
                                    type="submit"
                                >
                                    <i className="fa fa-arrow-left mr-2"/>
                                    {I18n[lang].back}
                                </Button>
                            </Link>
                        }
                        <Form onSubmit={this.handleSubmit}>
                            <Row>
                                <Col xs="12" md="8" lg="8">
                                    {this.renderOrderForm()}
                                </Col>
                                <Col xs="12" md="4" lg="4">
                                    {this.renderBankList()}
                                </Col>
                            </Row>

                            <div className='text-center mt-5'>
                                <Button
                                    className="ml-1"
                                    color="primary"
                                    type="submit"
                                    disabled={isSaveDisable}
                                >
                                    {isSaveDisable ? <i className="fa fa-spinner fa-spin mr-2"/> : null}
                                    {I18n[lang].createOrder}
                                </Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createLoanOrder: (order, lang) => dispatch(createLoanOrder(order, lang)),
        fetchBanks: query => dispatch(fetchLoanBanks(query)),
        fetchStores: query => dispatch(fetchStores(query)),
        fetchMaxNumberOfPayments: (query) => dispatch(fetchMaxNumberOfLoanPayments(query)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    currentUser: state.currentUser,
    loanBanks: state.loanBanks.loanBanks,
    maxNumberOfPayments: state.maxNumberOfLoanPayments.maxNumberOfPayments,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    stores: state.storesReducer.stores,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanOrderCreation);


// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrderCreation.js